import { useContext } from "react";

import { SessionContext, type SessionContextValue } from "@/state/session";

/** Access the current session (user + CSRF token). Must be used within AuthProvider. */
export function useCurrentUser(): SessionContextValue {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useCurrentUser must be used within an AuthProvider");
  }
  return context;
}
